import { makeAutoObservable } from "mobx";

export class PaymentResponseDto {
  type: number;
  paymentIntentResp: StripePaymentResponse
  // error: Error;
  successful: boolean;

  constructor(
    data: {
      type: number,
      paymentIntentResp: StripePaymentResponse,
      successful: boolean
    }) {

    this.type = data.type
    this.paymentIntentResp = data.paymentIntentResp
    this.successful = data.successful
    makeAutoObservable(this)
  }
}

export class StripePaymentResponse {
  id: string;
  checkoutId: string;
  clientSecret: string;
  amount: number;

  constructor(
    data: {
      id: string,
      checkoutId: string,
      clientSecret: string,
      amount: number
    }) {

    this.id = data.id
    this.checkoutId = data.checkoutId
    this.clientSecret = data.clientSecret
    this.amount = data.amount
    makeAutoObservable(this)
  }
}